import { ReactNode } from 'react';
import styled from 'styled-components';

import { Horizontal } from 'atoms/layout/flex';

const Root = styled(Horizontal).attrs({ gap: 2 })`
  overflow: auto;
  scroll-snap-type: x mandatory;
  padding: 0 var(--container-padding);
  margin: 0 calc(-1 * var(--container-padding));
  > * {
    scroll-snap-align: center;
    white-space: nowrap;
    width: max-content;
  }
`;

type Props = {
  children: ReactNode;
};

export const FlatList = ({ children }: Props) => {
  return <Root>{children}</Root>;
};
